/**
 * Convierte una cantidad de bytes a un texto legible ("2.4 MB", "512 KB", "800 B").
 * Devuelve "—" si el valor no es un número válido.
 */
export function fileSizeReadable(bytes) {
  if (bytes == null || isNaN(bytes)) return '—'
  const b = Number(bytes)
  if (b < 1024) return `${b} B`
  const kb = b / 1024
  if (kb < 1024) return `${kb.toFixed(1)} KB`
  const mb = kb / 1024
  if (mb < 1024) return `${mb.toFixed(1)} MB`
  const gb = mb / 1024
  return `${gb.toFixed(1)} GB`
}
